module.exports = __webpack_public_path__ + "media/images/payments/cirrus-dark-01473a4b1a1515654d1284e06a565487.svg";